import { Sidebar } from './Sidebar';
import { PreviewPane } from './PreviewPane';
import { SettingsPanel } from './SettingsPanel';
import { useHydrateStagedDraft } from '@/queries/stagedDraft';

export function EditorShell() {
  // Single owner of staged-draft hydration — all panels read the staged
  // working copy, only this mount adopts fresh server data into it.
  useHydrateStagedDraft();

  return (
    <div
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'row',
        overflow: 'hidden',
        minHeight: 0,
      }}
    >
      <Sidebar />
      <PreviewPane />
      <SettingsPanel />
    </div>
  );
}
